<template>
  <footer>
    <v-footer color="primary">
      <v-flex text-xs-center>
        <h6>We Are An Equal Opportunity Employer</h6>
      </v-flex>
    </v-footer>
  </footer>
</template>

<script>
export default {
  name: "job-application-footer",
  data() {
    return {};
  }
};
</script>

<style scoped>
h6 {
  margin: 10px;
  color: white;
  font-variant: small-caps;
}
</style>
